import { tooltipAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { base, variants } from '../common/TooltipAndToggletip.common';

const tooltipSlotRecipe = defineSlotRecipe({
  className: 'tooltip',
  slots: tooltipAnatomy.keys(),
  base: {
    ...base,
    positioner: {
      ...base.positioner,
      // A tooltip holds only text, so it never takes the pointer.
      pointerEvents: 'none',
    },
  },
  variants,
  defaultVariants: {
    variant: 'dark',
    paddingSize: 'md',
    textStyle: 'md/regular',
  },
});

export default tooltipSlotRecipe;
